// @ts-nocheck
import * as React from "react";

const DotsHorizontal: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M6.46 13a.963.963 0 0 1-.705-.294A.963.963 0 0 1 5.46 12c0-.275.098-.51.294-.706A.963.963 0 0 1 6.46 11c.275 0 .51.098.706.294a.963.963 0 0 1 .294.706c0 .275-.098.51-.294.706a.963.963 0 0 1-.706.294ZM12 13a.963.963 0 0 1-.707-.294A.963.963 0 0 1 11 12c0-.275.098-.51.294-.706A.963.963 0 0 1 12 11c.275 0 .51.098.707.294a.963.963 0 0 1 .293.706c0 .275-.098.51-.293.706a.963.963 0 0 1-.707.294Zm5.538 0a.963.963 0 0 1-.706-.294.963.963 0 0 1-.294-.706c0-.275.098-.51.294-.706a.963.963 0 0 1 .706-.294c.275 0 .51.098.706.294a.963.963 0 0 1 .294.706c0 .275-.098.51-.294.706a.963.963 0 0 1-.706.294Z"
            />
        </svg>
    );
};

export default React.memo(DotsHorizontal);
